var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeHide(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 .468h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.199 7.51A14.205 14.205 0 0 0 16 6.528c-6.364 0-11.798 4.204-14 10.138 1.06 2.855 2.867 5.309 5.166 7.087m1.562 1.06A14.27 14.27 0 0 0 16 26.802c6.364 0 11.798-4.203 14-10.137-1.316-3.546-3.786-6.474-6.919-8.257m-3.074 3.418C21.23 12.994 22 14.687 22 16.57c0 3.518-2.688 6.373-6 6.373-1.569 0-2.997-.64-4.067-1.688m-1.244-1.719A6.658 6.658 0 0 1 10 16.569c0-3.517 2.688-6.372 6-6.372.772 0 1.51.155 2.188.438",
    stroke: "#22272A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#22272A",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M3.352 30.666 28.047 2.468"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eyeHide.a1bf897208dcf6cd1ac0a7bccda0d10e.svg";
export { ForwardRef as ReactComponent };